
import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import Input from '@/components/Input';
import CodeButton from '@/components/CodeInput/CodeButton';

interface ICodeInput {
  value?: string;
  disable?: boolean;
  click?: any;
  change?: any;
  placeholder?: string;
  codeButtonText?: string;
  error?: boolean
}
@Component
export default class CodeInput extends tsx.Component<ICodeInput> {
  
  @Prop() public click!: any;
  @Prop() public change!: any;
  @Prop({default: false}) public disable!: boolean;
  @Prop() public placeholder!: string;
  @Prop() public value!: string;
  @Prop() public codeButtonText!: string;
  @Prop({default: false}) public error?: boolean
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {value, disable, click, change, placeholder, codeButtonText } = this.$props;
    return (
      <div>
        <Input error={this.$props.error} value={value} change={change}  placeholder={placeholder} iconName='code' rightItem={
          <CodeButton disable={disable} click={click}>{codeButtonText}</CodeButton>
        }  />
      </div>
    )
  }
  
}